import { Button, Grid, TextField } from "@material-ui/core";

const AddBlImportForm = () => {
  return (
    <Grid container spacing={2} style={{ paddingTop: 10 }}>
      <Grid item xs={12} md={4} lg={4}>
        <TextField
          label="N° Embarque"
          fullWidth
          variant="outlined"
          placeholder="Ingrese número de embarque"
        />
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <Button variant="contained" color="primary">
          Guardar
        </Button>
      </Grid>
    </Grid>
  );
};

export default AddBlImportForm;
